import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  selectDelivery: ['delivery'],

  deliveryRequest: ['isChangeQuantity', 'sellerId'],
  deliverySuccess: [],
  deliveryFailed: ['error'],

  thirdsAuthorizationRequest: ['sellerId', 'third'],
  thirdsAuthorizationSuccess: ['sellerId', 'third'],
  thirdsAuthorizationFailed: ['sellerId', 'error'],

  thirdsRequest: [''],
  thirdsSuccess: ['data'],
  thirdsFailed: ['sellerId', 'error'],

  thirdsDeleteRequest: ['sellerId', 'thirdId'],
  thirdsDeleteSuccess: ['sellerId'],
  thirdsDeleteFailed: ['sellerId', 'error'],
});

const INITIAL_STATE = Immutable({
  thirds: {},
  selectedDelivery: {},
  error: {},
  success: {},
  isLoading: false,
});

const request = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

const requestError = (state = INITIAL_STATE, { error, sellerId }) =>
  state.setIn(['error', sellerId], error).merge({ isLoading: false });

const selectDelivery = (state = INITIAL_STATE, { delivery }) =>
  state.merge({ selectedDelivery: { ...state.getIn(['selectedDelivery']), ...delivery }, error: {} });

const deliveryFailed = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });
const deliverySuccess = (state = INITIAL_STATE) => state.set('isLoading', false);

const thirdsSuccess = (state = INITIAL_STATE, { data }) => {
  const thirds = {};

  data.forEach((third) => {
    thirds[third.seller.id] = third;
  });

  return state.merge({ thirds, isLoading: false });
};

const thirdsDeleteSuccess = (state = INITIAL_STATE, { sellerId }) =>
  state.merge({ thirds: state.getIn(['thirds']).without(sellerId), isLoading: false });

const thirdsAuthorizationSuccess = (state = INITIAL_STATE, { sellerId, third }) =>
  state.merge({ isLoading: false }).setIn(['thirds', sellerId], third);

export default createReducer(INITIAL_STATE, {
  [Types.SELECT_DELIVERY]: selectDelivery,

  [Types.SELECT_DELIVERY]: selectDelivery,

  [Types.DELIVERY_REQUEST]: request,
  [Types.DELIVERY_SUCCESS]: deliverySuccess,
  [Types.DELIVERY_FAILED]: deliveryFailed,

  [Types.THIRDS_REQUEST]: request,
  [Types.THIRDS_SUCCESS]: thirdsSuccess,
  [Types.THIRDS_FAILED]: requestError,

  [Types.THIRDS_DELETE_REQUEST]: request,
  [Types.THIRDS_DELETE_SUCCESS]: thirdsDeleteSuccess,
  [Types.THIRDS_DELETE_FAILED]: requestError,

  [Types.THIRDS_AUTHORIZATION_REQUEST]: request,
  [Types.THIRDS_AUTHORIZATION_SUCCESS]: thirdsAuthorizationSuccess,
  [Types.THIRDS_AUTHORIZATION_FAILED]: requestError,
});
